var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66683 0.666016H20.3335C20.6871 0.666016 21.0263 0.806491 21.2763 1.05654C21.5264 1.30659 21.6668 1.64573 21.6668 1.99935V25.9993C21.6668 26.353 21.5264 26.6921 21.2763 26.9422C21.0263 27.1922 20.6871 27.3327 20.3335 27.3327H1.66683C1.31321 27.3327 0.974069 27.1922 0.724021 26.9422C0.473972 26.6921 0.333496 26.353 0.333496 25.9993V1.99935C0.333496 1.64573 0.473972 1.30659 0.724021 1.05654C0.974069 0.806491 1.31321 0.666016 1.66683 0.666016ZM7.00016 12.666V8.66602L0.333496 13.9993L7.00016 19.3327V15.3327H15.0002V12.666H7.00016Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.5457dc932d3fb6af120e676ef6e1389e.svg";
export { ForwardRef as ReactComponent };